module.exports = __webpack_public_path__ + "img/trash.81a60e66.png";